// extracted by mini-css-extract-plugin
export var cancelButton = "_oq-5";
export var content = "_oq-3";
export var createButton = "_oq-6";
export var drawerContainer = "_oq-0";
export var footer = "_oq-2";
export var header = "_oq-1";
export var orderFormColumn = "_oq-4";